.loading-overlay {
  position: relative;
}

.loading-overlay__loading {
  pointer-events: none;
}

.loading-overlay .loading-overlay__loading-indicator {
  position: absolute;
  inset: 0;

  pointer-events: none;
  backdrop-filter: blur(1px);

  z-index: 9999;

  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: center;

  color: var(--color-main-1);
}
